import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TableModule } from 'primeng/table';
import { Subscription } from 'rxjs';
import { Binder, OwnerItem } from 'src/app/models/binder.model';
import { StandardOwnerItem } from 'src/app/models/standard-owner-item.model';
import { UserAccessService } from 'src/app/services/app/user-access.service';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { TextareaModule } from 'primeng/textarea';
import { BinderService } from '@/services/api/binder.service';
import { SettingsDialogService } from '@/services/app/settings-dialog.service';
import { OwnerItemsService } from '@/services/api/owner-items.service';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-owner-items-settings',
    imports: [
      CommonModule,
      TableModule,
      ScrollPanelModule,
      ButtonModule,
      CurrencyPipe,
      InputTextModule,
      FormsModule,
      ReactiveFormsModule,
      TextareaModule,
      InputGroupModule,
      InputGroupAddonModule,
      ConfirmPopupModule
  ],
    template: `
    <div #ownerItemsSettingsDialog>
    <div class="flex flex-column md:flex-row gap-5">
        <div class="flex-auto" style="max-width: 50%;">
            <!-- <p-scrollPanel [style]="{ width: '100%', height: '600px' }" styleClass="custombar1"> -->
                <p-table [value]="standardOwnerItems" [scrollable]="true" scrollHeight="75vh">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Name</th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>{{ item.Item }}</td>
                            <td>
                                <p-inputGroup>
                                    <input type="number" pInputText placeholder="Price" [(ngModel)]="item.ItemPrice"
                                        class="w-10rem" />
                                    <button type="button" pButton icon="pi pi-plus" class="p-button-success"
                                        (click)="addOwnerItem(item, item.ItemPrice)"></button>
                                </p-inputGroup>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            {{itemLength}} options.
                        </div>
                    </ng-template>
                </p-table>
            <!-- </p-scrollPanel> -->
        </div>
        <div class="flex-auto">
            <!-- <p-scrollPanel [style]="{ width: '100%', height: '600px' }" styleClass="custombar2"> -->
                <p-table [value]="ownerItemsService.items()" dataKey="ItemID" editMode="row" [scrollable]="true" scrollHeight="75vh" (onRowReorder)="reorderRow($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th *ngIf="editAccess" style="width:10%"></th>
                            <th style="width:60%">Name</th>
                            <th style="width:20%">Price</th>
                            <th style="width:10%" *ngIf="editAccess"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item let-editing="editing" let-ri="rowIndex" let-index="rowIndex">
                        <tr [pEditableRow]="item"
                        [pReorderableRow]="index">
                        <td *ngIf="editAccess">
                            <span class="pi pi-bars" pReorderableRowHandle></span>
                        </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">

                                        <textarea rows="2" class="w-full" pTextarea [autoResize]="true"
                                            [(ngModel)]="item.Item">
</textarea>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{item.Item}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input type="number" pInputText placeholder="Price" [(ngModel)]="item.Priceint"
                                            class="w-10rem" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{item.Priceint | currency}}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="editAccess">
                                <div class="flex align-items-center justify-content-center gap-2">
                                    <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow
                                        icon="pi pi-pencil" (click)="onRowEditInit(item)"
                                        class="p-button-rounded p-button-text">
                                    </button>
                                    <button *ngIf="!editing" 
                                        pButton 
                                        pRipple 
                                        type="button"
                                        icon="pi pi-trash"
                                        (click)="confirm($event, item)"
                                        class="p-button-rounded p-button-text p-button-danger">
                                    </button>
                                    <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow
                                        icon="pi pi-check" (click)="onRowEditSave(item)"
                                        class="p-button-rounded p-button-text p-button-success mr-2">
                                    </button>
                                    <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow
                                        icon="pi pi-times" (click)="onRowEditCancel(item, ri)"
                                        class="p-button-rounded p-button-text p-button-danger">
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                    <tr>
                      <td colspan="4">
                        <h2>Add Custom Item</h2>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <p-inputGroup class="w-full">
                            <!-- <input type="text" pInputText placeholder="Item" [(ngModel)]="customItem" class="w-full" /> -->
                            <textarea pTextarea id="over_label" [(ngModel)]="customItem" rows="1" cols="30" autoResize style="resize: none" class="h-full"></textarea>
                            <input type="number" pInputText placeholder="Price" [(ngModel)]="customPrice"
                                class="w-2rem" />
                            <button type="button" pButton icon="pi pi-plus" class="p-button-success"
                                (click)="addCustomItem()"></button>
                        </p-inputGroup>
                      </td>
                    </tr>
                    </ng-template>
                </p-table>
            <!-- </p-scrollPanel> -->
        </div>
    </div>
    <div class="flex flex-col sm:flex-row w-full gap-4">
        <span class="text-right mr-3">Total Owner's Responsibility:  <b class="text-xl">{{ selectedTotal | currency }}</b></span>
            <p-button (onClick)="saveOwnerItems()" icon="pi pi-pencil" class="sm:ml-auto" label="Save"></p-button>
        </div>
</div>
        
<p-confirmpopup #oiConfirm key='oiConfirm' group='oiConfirm'>
    <ng-template #headless let-message>
        <div class="rounded p-4">
            <span>{{ message.message }}</span>
            <div class="flex items-center gap-2 mt-4">
                <p-button (onClick)="oiConfirm.onAccept()" label="Delete" size="small" severity="danger" />
                <p-button (onClick)="oiConfirm.onReject()" label="Cancel" [text]="true" size="small" severity="secondary" />
            </div>
        </div>
    </ng-template>
</p-confirmpopup>
    `,
    
})
export class OwnerItemsSettingsComponent {

  public ownerItemsService = inject(OwnerItemsService);
  private currentBinderService = inject(BinderService);
  private settingsDialogService = inject(SettingsDialogService);
  private userAccessService = inject(UserAccessService);
  private confirmationService = inject(ConfirmationService);
  // standardOwnerItems: StandardOwnerItem[] = [];
  // selectedOwnerItems: OwnerItem[] = [];
  clonedItems: { [itemId: number]: OwnerItem } = {};
  editAccess: boolean = false;
  // saving: boolean = false;



  binderId: number = 0;
  customItem: string = '';
  customPrice: number = 0;

  constructor(
    // private ownerItemsService: OwnerItemsService,
    // private currentBinderService: BinderService,
    // private settingsDialogService: SettingsDialogService,
    // private userAccessService: UserAccessService
  ) { 
    this.ownerItemsService.getStandardOwnerItems();
    effect(() => {
      const binder = this.currentBinderService.currentBinder();
      const ownerItems = this.ownerItemsService.ownerItems();
      const editAccess = this.userAccessService.binderEditAccess();
      const isOpen = this.settingsDialogService.isDialogOpen();
      const standardOwnerItems = this.ownerItemsService.standardOwnerItems();
      if(binder) {
        this.binderId = binder.BinderID;
      }
      this.editAccess = editAccess;
      if(!isOpen) {
        this.resetOwnerItems();
      }
      if(standardOwnerItems) {
        console.log('standard owner items:', standardOwnerItems);
        this.resetClonedOwnerItems();
      }
    })
  }

  get standardOwnerItems() {
    return this.ownerItemsService.standardOwnerItems().filter(item => !this.ownerItemsService.items().some(i => i.Item === item.Item));
  }

  resetClonedOwnerItems() {
    this.clonedItems = {};
  }

  get selectedTotal() {
    return this.ownerItemsService.items().reduce((total, item) => total + item.Priceint, 0);
  }

  get itemLength() {
    return this.ownerItemsService.items().length;
  }

  confirm(event: Event, item: OwnerItem) {
    this.confirmationService.confirm({
        
        target: event.target as EventTarget,
        key: 'oiConfirm',
        message: 'Are you sure you want to delete this item?',
        rejectButtonProps: {
            icon: 'pi pi-times',
            label: 'Cancel',
            outlined: true,
        },
        acceptButtonProps: {
            icon: 'pi pi-check',
            label: 'Confirm',
        },
        accept: () => {
            this.removeOwnerItem(item);
        },
        reject: () => {

        },
    });
  }

  // populateSelectedOwnerItems(binder: Binder) {
  //   if (binder.OwnerItems) {
  //     this.selectedOwnerItems = binder.OwnerItems.sort((a, b) => a.ItemOrder - b.ItemOrder);
  //     this.originalOwnerItems = [...this.selectedOwnerItems];
  //   }
  //   console.log('selected owner items:', this.selectedOwnerItems);
  // }

  addCustomItem() {
    const nextItemOrder = this.ownerItemsService.items().length > 0
      ? this.ownerItemsService.items().length + 1 : 0;
    const nextId = this.ownerItemsService.items().length > 0
      ? Math.max(...this.ownerItemsService.items().map(item => item.ItemID)) + 1
      : 1;
    const newOwnerItem: OwnerItem = {
      BinderID: this.binderId,
      Item: this.customItem,
      ItemOrder: nextItemOrder,
      Priceint: this.customPrice,
      ItemID: nextId,
      SOID: null,
      Responsibility: null,
      // StandardOwnerItems: null
    };
    this.ownerItemsService.addItem(newOwnerItem);
    // console.log('added items:', this.ownerItemsService.addedOwnerItems());
    this.customItem = '';
    this.customPrice = 0;
  }


  addOwnerItem(item: StandardOwnerItem, price: number) {
    const nextItemOrder = this.ownerItemsService.items().length > 0
      ? this.ownerItemsService.items().length + 1 : 0;
    const nextId = this.ownerItemsService.items().length > 0
      ? Math.max(...this.ownerItemsService.items().map(item => item.ItemID)) + 1
      : 1;
    console.log('next id:', nextId);
    const newOwnerItem: OwnerItem = {
      BinderID: this.binderId,
      Item: item.Item,
      ItemOrder: nextItemOrder,
      Priceint: price,
      ItemID: nextId,
      SOID: item.SOID,
      Responsibility: 0,
      // StandardOwnerItems: item
    };
    this.ownerItemsService.addItem(newOwnerItem);
    // console.log('added items:', this.ownerItemsService.addedOwnerItems());
  }

  removeOwnerItem(item: OwnerItem) {
    console.log('removing item:', item);
    this.ownerItemsService.deleteItem(item);
  }

  saveOwnerItems() {
    // this.saving = true;
    // console.log('saving owner items', this.addedOwnerItems, this.removedOwnerItems, this.editedOwnerItems);
    this.ownerItemsService.save();
  }

  onRowEditInit(item: OwnerItem) {
    this.clonedItems[item.ItemID] = { ...item };
  }
  
  onRowEditSave(item: OwnerItem) {
    // Optionally validate here (e.g. if item.Priceint < 0)
    delete this.clonedItems[item.ItemID];
    // this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Row saved locally' });
  }
  
  onRowEditCancel(item: OwnerItem, index: number) {
    const clone = this.clonedItems[item.ItemID];
    if (clone) {
      this.ownerItemsService.updateItem(index, clone);
      delete this.clonedItems[item.ItemID];
    }
  }

  // onRowEditInit(item: OwnerItem) {
  //   this.clonedOwnerItems[item.ItemID] = { ...item };
  // }

  // onRowEditSave(item: OwnerItem) {
  //   const addedItemIndex = this.ownerItemsService.addedOwnerItems().findIndex(i => i.ItemID === item.ItemID);
  //   const editedItemIndex = this.ownerItemsService.editedOwnerItems().findIndex(i => i.ItemID === item.ItemID);
  //   if (addedItemIndex !== -1) {
  //     // Replace the item in addedOwnerItems if it exists there
  //     this.ownerItemsService.addedOwnerItems()[addedItemIndex] = item;
  //   } else if (editedItemIndex !== -1) {
  //     this.ownerItemsService.editedOwnerItems()[addedItemIndex] = item;
  //   } else {
  //     this.ownerItemsService.editedOwnerItems().push(item);
  //   }
  // }

  // onRowEditCancel(item: OwnerItem, index: number) {
  //   this.selectedOwnerItems[index] = this.clonedOwnerItems[item.ItemID];
  //   delete this.clonedOwnerItems[item.ItemID];
  // }

  resetOwnerItems() {
    this.ownerItemsService.reset();
  }

  canSave() {
    return this.ownerItemsService.isDirty();
  }

  reorderRow(event: any) {
    const items = [...this.ownerItemsService.items()]; // clone local signal value
    const draggedItem = items[event.dragIndex];
  
    // Remove and re-insert
    items.splice(event.dragIndex, 1);
    items.splice(event.newIndex, 0, draggedItem);
  
    // Update order field
    items.forEach((item, index) => {
      item.ItemOrder = index + 1; // or zero-based if preferred
    });
  
    // Push update to service
    this.ownerItemsService.setItems(items); // you'll add this method in service
  }
  

}
